export const CHANGELOG_VERSION = "25.11.03";

export interface ChangelogItem {
  icon: string;
  title: string;
  description: string;
  link?: {
    url: string;
    text: string;
  };
}

export const changelogContent = {
  title: "Novedades de DoctIA",
  items: [
    {
      icon: "🔍",
      title: "Filtros avanzados de búsqueda",
      description:
        "Ahora podés refinar tus resultados con filtros por fecha, términos a incluir y términos a excluir. Los términos que coinciden se resaltan automáticamente en los resultados para encontrarlos más fácilmente.",
    },
    {
      icon: "📚",
      title: "Sección de Ayuda mejorada",
      description:
        "Renovamos completamente la sección de ayuda con tutoriales en video y guías paso a paso.",
      link: {
        url: "/ayuda",
        text: "Ver la nueva sección de ayuda →",
      },
    },
    {
      icon: "✨",
      title: "Nueva colección: Tribunal Superior de la CABA",
      description:
        "Ahora DoctIA también encuentra jurisprudencia del TSJ-CABA, que será clave en la era post-Levinas (CSJN). Probala hoy!",
    },
    {
      icon: "🚀",
      title: "Próximamente",
      description: "En breve incorporaremos también jurisprudencia de la SCBA!",
    },
  ],
};
